exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3 {\n    text-align: center;\n}\n.page-header {\n    margin-top: 0;\n    font-weight: bold;\n}\n.login-wrapper {\n    margin-top: 3em;\n}\nbutton[type=\"submit\"] {\n    font-size: 1.125em;\n    display: block;\n    margin: 0 auto;\n}\n.login-logo {\n    width: 200px;\n    margin-bottom: 20px;\n}\n.login-logo-wrapper {\n    width: 100%;\n    text-align: center;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /root/anvel/angular/app/components/defaults/login/login.component.css
// module id = ../../../../../angular/app/components/defaults/login/login.component.css
// module chunks = 1